module.exports = __webpack_public_path__ + "img/Cricket.3c018767.svg";